// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponseListPendingEvaluation,
  GenericApiResponseModuleGradeResult,
  GetEvaluationsForLecturerParams,
  GradePreviewRequest,
  HTTPValidationError,
} from '../../models';

/**
 * List for lecturers: list of evaluations with pagination and filtering support.

Supports standardized filtering and sorting via query parameters.
 * @summary Get Evaluations For Lecturer
 */
export const getEvaluationsForLecturer = (
  params?: GetEvaluationsForLecturerParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListPendingEvaluation>> => {
  return axios.get(`/users/me/evaluations`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetEvaluationsForLecturerQueryKey = (params?: GetEvaluationsForLecturerParams) => {
  return [`/users/me/evaluations`, ...(params ? [params] : [])] as const;
};

export const getGetEvaluationsForLecturerQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvaluationsForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEvaluationsForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluationsForLecturer>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEvaluationsForLecturerQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvaluationsForLecturer>>> = ({ signal }) =>
    getEvaluationsForLecturer(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvaluationsForLecturer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEvaluationsForLecturerQueryResult = NonNullable<Awaited<ReturnType<typeof getEvaluationsForLecturer>>>;
export type GetEvaluationsForLecturerQueryError = AxiosError<void | HTTPValidationError>;

export function useGetEvaluationsForLecturer<
  TData = Awaited<ReturnType<typeof getEvaluationsForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: undefined | GetEvaluationsForLecturerParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluationsForLecturer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getEvaluationsForLecturer>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEvaluationsForLecturer<
  TData = Awaited<ReturnType<typeof getEvaluationsForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEvaluationsForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluationsForLecturer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getEvaluationsForLecturer>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEvaluationsForLecturer<
  TData = Awaited<ReturnType<typeof getEvaluationsForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEvaluationsForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluationsForLecturer>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Evaluations For Lecturer
 */

export function useGetEvaluationsForLecturer<
  TData = Awaited<ReturnType<typeof getEvaluationsForLecturer>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetEvaluationsForLecturerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvaluationsForLecturer>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEvaluationsForLecturerQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Compute a module grade preview from in-progress task evaluations.

This is the canonical backend aggregator. The FE evaluation desk delegates
to this endpoint instead of running the grade calculation client-side.
 * @summary Preview Module Grade
 */
export const previewModuleGrade = (
  gradePreviewRequest: GradePreviewRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleGradeResult>> => {
  return axios.post(`/grade-preview`, gradePreviewRequest, options);
};

export const getPreviewModuleGradeMutationOptions = <
  TData = Awaited<ReturnType<typeof previewModuleGrade>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: GradePreviewRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['previewModuleGrade'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewModuleGrade>>, { data: GradePreviewRequest }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return previewModuleGrade(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: GradePreviewRequest },
    TContext
  >;
};

export type PreviewModuleGradeMutationResult = NonNullable<Awaited<ReturnType<typeof previewModuleGrade>>>;
export type PreviewModuleGradeMutationBody = GradePreviewRequest;
export type PreviewModuleGradeMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Preview Module Grade
 */
export const usePreviewModuleGrade = <
  TData = Awaited<ReturnType<typeof previewModuleGrade>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: GradePreviewRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: GradePreviewRequest }, TContext> => {
  const mutationOptions = getPreviewModuleGradeMutationOptions(options);

  return useMutation(mutationOptions);
};
